import {
  UPDATE_ALL_COMPONENTS,
  UPDATE_COMPONENT,
  QUESTIONARIO_COMPONENT,
  SIDE_UPDATE_COMPONENT,
  VALIDATE_COMPONENT_SUCCESS,
  VALIDATE_COMPONENT_FAILED,
  SIDE_VALIDATE_COMPONENT_SUCCESS,
  SIDE_VALIDATE_COMPONENT_FAILED,
  SERVER_VALIDATE_COMPONENT_SUCCESS,
  SERVER_VALIDATE_COMPONENT_FAILED,
  AUTOFILL_COMPONENT_START,
  AUTOFILL_COMPONENT_DONE,
  AUTOFILL_COMPONENT_FAILED
} from '../actions/componentsActions'
import { arraysEqual } from '../../utils'

/**
 * Components Reducer
 * @module  {Reducer} componentReducer
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
export default (state = {}, action) => {
  switch (action.type) {
    case UPDATE_ALL_COMPONENTS:
      if (
        arraysEqual(Object.keys(state), Object.keys(action.components || {}))
      ) {
        // this loop avoids to refetch the select options if the flow returns validation errors on step
        Object.keys(action.components).forEach(
          k => (action.components[k].values = state[k].values)
        )

        return { ...action.components }
      } else {
        return Object.keys(action.components).reduce((newState, k) => {
          newState[k] = { ...state[k], ...action.components[k] }
          return newState
        }, {})
      }
    case UPDATE_COMPONENT:
    case SIDE_UPDATE_COMPONENT:
    case VALIDATE_COMPONENT_SUCCESS:
    case VALIDATE_COMPONENT_FAILED:
    case SIDE_VALIDATE_COMPONENT_SUCCESS:
    case SIDE_VALIDATE_COMPONENT_FAILED:
    case SERVER_VALIDATE_COMPONENT_SUCCESS:
    case SERVER_VALIDATE_COMPONENT_FAILED:
    case AUTOFILL_COMPONENT_START:
    case AUTOFILL_COMPONENT_DONE:
    case AUTOFILL_COMPONENT_FAILED:
      const newState = {
        ...state,
        [action.component.id]: {
          ...state[action.component.id],
          ...action.component
        }
      }
      return newState
    case QUESTIONARIO_COMPONENT:
      /* */
      return newState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./state/reducers/componentsReducer.js